import axios from 'axios';
import nProgress from 'nprogress';

/**
 * Get Brands by name
 * https://github.com/axios/axios/issues/1361#issuecomment-417880626
 * @returns {function(): Promise<unknown>}
 */

let call;

const requestProgress = (config) => {
  nProgress.start();

  config.headers.common.Authorization = `Bearer ${localStorage.getItem('jwt_token')}`;
  return config;
};

/** Adding the request interceptors */
axios.interceptors.request.use(requestProgress);

/** Adding the response interceptors */
axios.interceptors.response.use(
  (response) => {
    nProgress.done();
    return response;
  },
  (error) => {
    nProgress.done();
    return Promise.reject(error.response.data);
  },
);

const oneRequest = (config = {}) => {
  if (call) {
    call.cancel('Only one request allowed at a time.');
  }
  call = axios.CancelToken.source();

  config.cancelToken = call.token;
  return axios(config);
};

export default oneRequest;
